import {
  getDefaultTextToKeyMap,
  getStaticTooltip,
  tooltipLookupKey,
} from "./tooltipCatalog";

/**
 * Module-level effective-text cache filled by TooltipProvider.
 * Enables existing tooltipComponent(staticDefault) call sites to pick up DB overrides
 * without rewriting every screen.
 */
const effectiveByKey = new Map<string, string>();

export function setEffectiveTooltipTexts(
  entries: Array<{ groupKey: string; fieldKey: string; text: string }>,
): void {
  effectiveByKey.clear();
  for (const item of entries) {
    effectiveByKey.set(
      tooltipLookupKey(item.groupKey, item.fieldKey),
      item.text,
    );
  }
}

export function clearEffectiveTooltipTexts(): void {
  effectiveByKey.clear();
}

export function getEffectiveTooltip(
  groupKey: string,
  fieldKey: string,
  fallback?: string,
): string {
  const key = tooltipLookupKey(groupKey, fieldKey);
  const fromDb = effectiveByKey.get(key);
  if (fromDb != null && fromDb.trim() !== "") return fromDb;
  if (fallback != null && fallback !== "") return fallback;
  return getStaticTooltip(groupKey, fieldKey);
}

/** Resolve static default string (as passed to tooltipComponent) to effective copy. */
export function resolveTooltipDisplayText(staticOrEffective: string): string {
  if (!staticOrEffective) return staticOrEffective;
  const key = getDefaultTextToKeyMap().get(staticOrEffective);
  if (key) {
    const fromDb = effectiveByKey.get(key);
    if (fromDb != null && fromDb.trim() !== "") return fromDb;
  }
  return staticOrEffective;
}

export function t(
  groupKey: string,
  fieldKey: string,
  fallback?: string,
): string {
  return getEffectiveTooltip(groupKey, fieldKey, fallback);
}
